import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg className={(styles["codicon"] || "codicon") + " " + (styles["codicon-play-150"] || "codicon-play-150")} viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><circle stroke="#FFF" strokeWidth="2" cx="75.011" cy="75.417" r="74" /><path fill="#FFF" d="M68.054 59.177l26.143 16.284-26.143 16.284z" /></g></svg>;